var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmotionsNeutral = function SvgEmotionsNeutral(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#emotions-neutral_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 7.5A1.667 1.667 0 1 1 5 7.5a1.667 1.667 0 0 1 3.333 0ZM15 7.5a1.667 1.667 0 1 1-3.333 0A1.667 1.667 0 0 1 15 7.5Zm-7.5 5.833A.833.833 0 0 0 7.5 15h5a.833.833 0 0 0 0-1.667h-5Z",
    fill: "#000"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "emotions-neutral_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(90 2.708 7.292) scale(15.4167)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.359,
    stopColor: "#AAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5E5E"
  })))));
};
export default SvgEmotionsNeutral;